module.exports = __webpack_public_path__ + "static/media/Clock_Icon@3x.3e965868.png";